import GoodsNameSearchModel from './GoodsNameSearchModel'

export default GoodsNameSearchModel
